import { useEffect, useState } from 'react';

import { User } from '@qality/common-model';
import { UserPropertyService } from '@qality/common-service';
import { isNumber } from '@qality/common-utils/src/TypeUtils';

export default function useBannerCloseCounter(
  counterKey: string,
  currentUser: User
) {
  const [isLoading, setIsLoading] = useState(true);
  const [bannerCloseCounter, setBannerCloseCounter] = useState<number>();

  useEffect(() => {
    loadBannerCloseCounter();
  }, []);

  const loadBannerCloseCounter = async () => {
    try {
      const property = await UserPropertyService.getProperty(
        counterKey,
        currentUser
      );

      setBannerCloseCounter(property.value);
    } catch (e) {
      if (e.xhr.status === 404) {
        // The property of that key doesn't exist yet
        setBannerCloseCounter(0);
      } else {
        // Every other error
        setBannerCloseCounter(null);
      }
    } finally {
      setIsLoading(false);
    }
  };

  const saveBannerCloseCounter = async (newBannerCloseCounter: number) => {
    try {
      UserPropertyService.setProperty(
        counterKey,
        newBannerCloseCounter,
        currentUser
      );
    } catch {
      // do nothing
    }
  };

  const incrementBannerCloseCounter = () => {
    if (!isNumber(bannerCloseCounter)) {
      return;
    }

    const newBannerCloseCounter = bannerCloseCounter + 1;

    setBannerCloseCounter(newBannerCloseCounter);
    saveBannerCloseCounter(newBannerCloseCounter);
  };

  return {
    isLoading,
    bannerCloseCounter,
    incrementBannerCloseCounter,
  };
}
